module.exports = __webpack_public_path__ + "img/valens-residence-web.922acd3e.jpg";